import React, { useCallback, useEffect, useRef } from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';
import { ChatGenericError } from '@atlassian/conversation-assistant-ui-components/ui/ChatGenericError';

export const SuccessEventComponent = ({
	action,
	onSuccess,
}: {
	action: MessageAction;
	onSuccess?: (action: MessageAction) => void;
}) => {
	const fired = useRef<boolean>(false);
	useEffect(() => {
		if (fired.current === true || !action) {
			return;
		}
		fired.current = true;
		onSuccess?.(action);
	}, [onSuccess, action]);
	return null;
};

export const ErrorBoundaryWithAnalytics = ({
	children,
	action,
	onError,
}: {
	children: React.ReactNode;
	action: MessageAction;
	onError?: (
		action: MessageAction,
		{ error, info }: { error: Error; info: React.ErrorInfo },
	) => void;
}): React.JSX.Element => {
	const onErrorCallback = useCallback(
		(error: Error, info: React.ErrorInfo) => {
			onError?.(action, { error, info });
		},
		[onError, action],
	);

	return (
		<ErrorBoundary fallback={<ChatGenericError errorType="generic" />} onError={onErrorCallback}>
			{children}
		</ErrorBoundary>
	);
};
